import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { leaderboardBettingOddsSelector } from 'store/modules/brownlow-tracker/leaderboard/selectors';
import { leaderboardDataSelector } from 'store/modules/brownlow-tracker/leaderboard/selectors';

export const MobileTable = ({ seasonPid, children, nextPageButton }) => {
    const bettingOdds = useSelector(leaderboardBettingOddsSelector);
    const leaderboardData = useSelector((state) =>
        leaderboardDataSelector(state, seasonPid)
    );

    const status = leaderboardData?.status
        ? PULSE.app.common.match.getMatchStatus(leaderboardData.status)
        : '';

    const modifier =
        bettingOdds.isActive &&
        status !== PULSE.app.common.CONSTANTS.MATCH_STATUS.COMPLETED
            ? 'brownlow-tracker-leaderboard-mobile-table--show-odds'
            : '';

    return (
        <>
            <div
                className={`brownlow-tracker-leaderboard-mobile-table ${modifier}`}
            >
                {children}
            </div>
            {nextPageButton}
        </>
    );
};

MobileTable.propTypes = {
    seasonPid: PropTypes.string.isRequired,
    children: PropTypes.any.isRequired,
    nextPageButton: PropTypes.any,
    modifier: PropTypes.string
};
